import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '../../api';
import TopBar from '../../Components/TopBar';
import Navbar from '../../Components/Navbar';
import Footer from '../../Components/Footer';

const VerifyCertificatePage = () => {
  const { code } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    verify();
  }, [code]);

  const verify = async () => {
    try {
      const res = await api.get(`/verify-certificate/${code}`);
      setData(res.data);
      setError('');
    } catch (err) {
      setError(err.response?.data?.message || 'Invalid certificate');
      setData(null);
    }
  };

  return (
    <>
      <TopBar />
      <main className="page-about">
        <div className="container">
          <Navbar />
          <div className="py-5">
            <h2>Certificate Verification</h2>
            {error && <div className="alert alert-danger mt-3">{error}</div>}
            {data?.valid && (
              <div className="card p-4 mt-3">
                <h4 className="text-success">Certificate is valid</h4>
                <p>
                  <strong>Certificate:</strong> {data.certificate_code}
                </p>
                <p>
                  <strong>Student:</strong> {data.student_name}
                </p>
                <p>
                  <strong>Course:</strong> {data.course_name}
                </p>
                <p>
                  <strong>Instructor:</strong> {data.instructor}
                </p>
                <p>
                  <strong>Issue Date:</strong> {data.issue_date}
                </p>
              </div>
            )}
          </div>
        </div>
        <Footer />
      </main>
    </>
  );
};

export default VerifyCertificatePage;
